"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const parseFile_1 = require("@/utils/parseFile");
const react_bootstrap_1 = require("react-bootstrap");
const ExcelPreview = ({ file, data, onRowSelect, onColumnSelect, onHeaderRowNumberSelect, onAddScriptIdFormat, onChangeOriginalScriptField, onSave, stale, }) => {
    var _a;
    const [excelData, setExcelData] = react_1.default.useState(null);
    const [rows, setRows] = react_1.default.useState([]);
    const [selectedRowNumber, setSelectedRowNumber] = (0, react_1.useState)((_a = data.headerRowNumber) !== null && _a !== void 0 ? _a : 1);
    const [selectedColIndexs, setSelectedColIndexs] = (0, react_1.useState)([]);
    const [menuState, setMenuState] = (0, react_1.useState)({
        type: null,
        target: null,
        index: null,
    });
    const tableRef = (0, react_1.useRef)(null);
    const [initialRender, setInitialRender] = (0, react_1.useState)(true);
    // Get placement based on menu type
    const getPlacement = () => {
        if (menuState.type === "row") {
            return "right";
        }
        else if (menuState.type === "column") {
            return "bottom";
        }
        return "right"; // デフォルト値
    };
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const data = yield (0, parseFile_1.readExcel)(file);
            setExcelData(data);
        }))();
    }, [file]);
    const sheet = excelData ? excelData.Sheets[excelData.SheetNames[0]] : null;
    // Extract rows and columns from the sheet data
    (0, react_1.useEffect)(() => {
        if (sheet) {
            const range = sheet["!ref"];
            if (range) {
                const [start, end] = range.split(":");
                const startRow = parseInt(start.match(/\d+/)[0], 10);
                const endRow = parseInt(end.match(/\d+/)[0], 10);
                const startColStr = start.match(/[A-Z]+/)[0];
                const endColStr = end.match(/[A-Z]+/)[0];
                // EXCEL 列番号を数値に変換
                const startCol = startColStr.split("").reduce((acc, char) => {
                    return acc * 26 + char.charCodeAt(0) - 64;
                }, 0) - 1;
                const endCol = endColStr.split("").reduce((acc, char) => {
                    return acc * 26 + char.charCodeAt(0) - 64;
                }, 0) - 1;
                const rows = [];
                for (let rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
                    const row = [];
                    for (let colIndex = startCol; colIndex <= endCol; colIndex++) {
                        const cellAddress = String.fromCharCode(65 + colIndex) + rowIndex;
                        const cell = sheet[cellAddress];
                        row.push(cell ? cell.v : "");
                    }
                    rows.push(row);
                }
                setRows(rows);
            }
        }
    }, [sheet]);
    (0, react_1.useEffect)(() => {
        if (rows && selectedRowNumber === undefined) {
            setSelectedRowNumber(() => {
                const index = rows.findIndex((row) => row.some((col) => {
                    var _a, _b, _c;
                    return (_c = [
                        ...((_a = data.columnsToSave) !== null && _a !== void 0 ? _a : []),
                        ...((_b = data.columnsToSaveOptional) !== null && _b !== void 0 ? _b : []),
                    ]) === null || _c === void 0 ? void 0 : _c.includes(col);
                }));
                return index === -1 ? 0 : index + 1;
            });
        }
    }, [rows, data.columnsToSaveOptional, data.columnsToSave]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (rows) {
            setSelectedColIndexs((_a = rows[selectedRowNumber - 1]) === null || _a === void 0 ? void 0 : _a.map((col, index) => {
                var _a, _b, _c;
                if ((_c = [
                    ...((_a = data.columnsToSave) !== null && _a !== void 0 ? _a : []),
                    ...((_b = data.columnsToSaveOptional) !== null && _b !== void 0 ? _b : []),
                ]) === null || _c === void 0 ? void 0 : _c.includes(col))
                    return index;
                return -1;
            }).filter((index) => index !== -1));
        }
    }, [rows, data.columnsToSaveOptional, data.columnsToSave, selectedRowNumber]);
    (0, react_1.useEffect)(() => {
        if (selectedRowNumber !== null) {
            onRowSelect === null || onRowSelect === void 0 ? void 0 : onRowSelect(selectedRowNumber);
        }
    }, [selectedRowNumber]);
    (0, react_1.useEffect)(() => {
        if (selectedRowNumber !== null) {
            const cols = selectedColIndexs === null || selectedColIndexs === void 0 ? void 0 : selectedColIndexs.map((index) => rows[selectedRowNumber - 1][index]);
            onColumnSelect === null || onColumnSelect === void 0 ? void 0 : onColumnSelect(cols === null || cols === void 0 ? void 0 : cols.filter((col) => { var _a; return !!col && !((_a = data.columnsToSave) === null || _a === void 0 ? void 0 : _a.includes(col)); }));
        }
    }, [selectedColIndexs, selectedRowNumber]);
    const handleSetHeaderRow = () => {
        onHeaderRowNumberSelect === null || onHeaderRowNumberSelect === void 0 ? void 0 : onHeaderRowNumberSelect(selectedRowNumber, rows[selectedRowNumber - 1]);
        // onSave(rows);
        setMenuState({ type: null, target: null, index: null });
    };
    const handleAddScriptId = () => {
        if (!rows[Math.max(selectedRowNumber - 1, 0)])
            return;
        onAddScriptIdFormat === null || onAddScriptIdFormat === void 0 ? void 0 : onAddScriptIdFormat(rows[Math.max(selectedRowNumber - 1, 0)][menuState.index || 0]);
        setMenuState({ type: null, target: null, index: null });
    };
    // Initial save
    (0, react_1.useEffect)(() => {
        if (selectedRowNumber !== undefined && rows.length && initialRender) {
            handleSetHeaderRow();
            handleAddScriptId();
            setInitialRender(false);
        }
    }, [rows]);
    const handleSelectRow = (rowNumber, event) => {
        setSelectedRowNumber(rowNumber);
        onRowSelect === null || onRowSelect === void 0 ? void 0 : onRowSelect(rowNumber);
        setMenuState({
            type: "row",
            target: event.currentTarget,
            index: rowNumber,
        });
    };
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        setSelectedRowNumber((_a = data.headerRowNumber) !== null && _a !== void 0 ? _a : 1);
        onRowSelect === null || onRowSelect === void 0 ? void 0 : onRowSelect((_b = data.headerRowNumber) !== null && _b !== void 0 ? _b : 1);
        onHeaderRowNumberSelect === null || onHeaderRowNumberSelect === void 0 ? void 0 : onHeaderRowNumberSelect((_c = data.headerRowNumber) !== null && _c !== void 0 ? _c : 1, rows[((_d = data.headerRowNumber) !== null && _d !== void 0 ? _d : 1) - 1]);
    }, [data.headerRowNumber]);
    if (!sheet) {
        return react_1.default.createElement("div", null, "Loading...");
    }
    if (rows.length === 0) {
        return react_1.default.createElement("div", null, "No data found");
    }
    const handleSelectColumn = (index, event) => {
        var _a, _b;
        if (selectedRowNumber !== null &&
            !((_a = data.columnsToSave) === null || _a === void 0 ? void 0 : _a.includes((_b = rows[selectedRowNumber - 1]) === null || _b === void 0 ? void 0 : _b[index]))) {
            const isIncluded = selectedColIndexs.includes(index);
            setSelectedColIndexs((prev) => {
                if (isIncluded) {
                    return prev.filter((col) => col !== index);
                }
                else {
                    return [...prev, index];
                }
            });
            if (isIncluded) {
                setMenuState({ type: null, target: null, index: null });
            }
            else {
                setMenuState({
                    type: "column",
                    target: event.currentTarget,
                    index,
                });
            }
        }
    };
    const handleSetTranslationId = () => {
        onChangeOriginalScriptField === null || onChangeOriginalScriptField === void 0 ? void 0 : onChangeOriginalScriptField(rows[Math.max(selectedRowNumber - 1, 0)][menuState.index || 0]);
        setMenuState({ type: null, target: null, index: null });
    };
    return (react_1.default.createElement("div", { ref: tableRef, style: { overflowX: "auto", position: "relative" } },
        react_1.default.createElement("div", { className: "d-flex justify-content-between mb-2" },
            react_1.default.createElement("p", { style: { fontWeight: 700 } }, "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u30D5\u30A1\u30A4\u30EB"),
            react_1.default.createElement("p", { style: { fontSize: 12, color: "#767676" } }, file.name)),
        react_1.default.createElement("table", { style: { width: "100%", borderCollapse: "collapse", margin: "0 auto" } },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", { style: {
                            border: "1px solid #ddd",
                            padding: "8px",
                            backgroundColor: "#3F3F46",
                            fontWeight: "bold",
                            textAlign: "center",
                        } }),
                    rows[0].map((_, index) => {
                        var _a, _b;
                        return (react_1.default.createElement("th", { key: index, style: {
                                color: "white",
                                border: "1px solid #ddd",
                                padding: "8px",
                                fontWeight: "bold",
                                textAlign: "center",
                                cursor: selectedRowNumber !== null &&
                                    !((_a = data.columnsToSave) === null || _a === void 0 ? void 0 : _a.includes((_b = rows[selectedRowNumber - 1]) === null || _b === void 0 ? void 0 : _b[index]))
                                    ? "pointer"
                                    : "default",
                                backgroundColor: (selectedColIndexs === null || selectedColIndexs === void 0 ? void 0 : selectedColIndexs.includes(index))
                                    ? "#2D73B9"
                                    : "#3F3F46",
                            }, onClick: (e) => {
                                e.stopPropagation();
                                handleSelectColumn(index, e);
                            } }, String.fromCharCode(65 + index)));
                    }))),
            react_1.default.createElement("tbody", null, rows.slice(0, 5).map((row, rowIndex) => (react_1.default.createElement("tr", { key: rowIndex, style: {
                    backgroundColor: selectedRowNumber - 1 === rowIndex ? "#F0F9FF" : "#FFFFFF",
                } },
                react_1.default.createElement("td", { style: {
                        border: "1px solid #ddd",
                        padding: "8px",
                        backgroundColor: selectedRowNumber - 1 === rowIndex ? "#F0F9FF" : "#FBFBFD",
                        fontWeight: "bold",
                        textAlign: "center",
                        cursor: "pointer",
                    }, onClick: (e) => {
                        e.stopPropagation();
                        handleSelectRow(rowIndex + 1, e);
                    } }, rowIndex + 1),
                row.map((cell, colIndex) => (react_1.default.createElement("td", { key: colIndex, style: Object.assign({ border: "1px solid #ddd", padding: "8px", textAlign: "left", height: "40px" }, ((selectedColIndexs === null || selectedColIndexs === void 0 ? void 0 : selectedColIndexs.includes(colIndex))
                        ? { backgroundColor: "#F0F9FF" }
                        : {})) }, cell)))))))),
        react_1.default.createElement(react_bootstrap_1.Overlay, { show: menuState.type !== null, target: menuState.target, placement: getPlacement(), rootClose: true, onHide: () => setMenuState({ type: null, target: null, index: null }) },
            react_1.default.createElement(react_bootstrap_1.Popover, { id: "menu" },
                react_1.default.createElement(react_bootstrap_1.Popover.Body, { className: "p-0" },
                    react_1.default.createElement("style", null, `
                .menu-item {
                  cursor: pointer;
                  padding: 8px;
                  border-radius: 8px;
                  transition: background-color 0.2s ease-in-out;
                }
                .menu-item:hover {
                  background-color: #f2f2f2;
                }
              `),
                    menuState.type === "row" ? (react_1.default.createElement("div", { role: "button", className: "menu-item", onClick: handleSetHeaderRow }, "\u898B\u51FA\u3057\u884C\u3068\u3057\u3066\u6307\u5B9A")) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { role: "button", className: "menu-item", onClick: (e) => {
                                handleAddScriptId();
                            } }, "Script ID \u306B\u3053\u306E\u5217\u3092\u8FFD\u52A0"),
                        react_1.default.createElement("div", { role: "button", className: "menu-item", onClick: (e) => {
                                handleSetTranslationId();
                            } }, "\u7FFB\u8A33\u524D\u30C7\u30FC\u30BF\u306E\u5217\u540D\u3068\u3057\u3066\u6307\u5B9A"))))))));
};
exports.default = ExcelPreview;
